var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShape21 = function SvgShape21(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 89,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M110.306 28.693c-4.363-6.922-8.802-13.94-14.7-19.437C89.708 3.746 82.067-.147 74.233.36 67.354.813 60.98 4.623 55.946 9.6c-5.034 4.975-8.944 11.103-12.79 17.175-10.402 16.393-20.818 32.787-31.22 49.194C6.993 83.754 1.921 91.882.553 101.162c-1.652 11.212 2.8 22.63 10.7 30.087 8.259 7.799 21.643 7.169 31.696 5.031 11.022-2.344 21.799-6.758 33.04-6.744 9.627 0 18.933 3.262 28.302 5.633 9.357 2.358 19.411 3.811 28.445.302 11.216-4.345 19.269-16.695 19.05-29.374-.207-11.57-12.545-31.527-12.545-31.527s-19.292-30.583-28.935-45.877",
    opacity: 0.1
  })));
};
export default SvgShape21;